import { ValidSessionRoute } from '@ferreri/minato-auth-react';
import { Loading, PageLayoutMenu } from '@ferreri/prever-component-lib';

import { VerifyAvailabilityBenefitUsage } from 'modules/contract/VerifyAvailabilityBenefitUsage';
import { TelevetMenu } from 'modules/televet/TelevetMenu';
import { PAGE_TITLE } from 'utils/pageTitle';

export default function TeleveterinaryPage() {
  return (
    <ValidSessionRoute
      loadingComponent={
        <PageLayoutMenu sideMenu={<TelevetMenu />} title={PAGE_TITLE.televet}>
          <Loading />
        </PageLayoutMenu>
      }
    >
      <PageLayoutMenu sideMenu={<TelevetMenu />} title={PAGE_TITLE.televet}>
        <VerifyAvailabilityBenefitUsage />
      </PageLayoutMenu>
    </ValidSessionRoute>
  );
}
